<template>
  <div class="report-wrap">
    <div class="header-text">总览报表</div>
    <allreport-filter
      ref="filterRef"
      @handleSearch="handleSearch"
      @downloadFile="downloadFile"
    ></allreport-filter>
    <div class="table-wrap">
      <allreport-table
        ref="tableRef"
        @closeDownLoadLoading="closeDownLoadLoading"
      ></allreport-table>
    </div>
  </div>
</template>

<script>
import AllreportFilter from "./allreportFilter";
import AllreportTable from "./allreportTable";
export default {
  name: "allreport",
  data() {
    return {};
  },
  computed: {},
  components: {
    AllreportFilter,
    AllreportTable,
  },
  mounted() {},
  methods: {
    handleSearch(value) {
      this.$refs.tableRef?.handleSearch(value);
    },
    downloadFile() {
      this.$refs.tableRef.downLoadFileToExcel();
    },
    closeDownLoadLoading() {
      this.$refs.filterRef.closeDownLoadLoading();
    },
  },
};
</script>
<style scoped>
.report-wrap {
  height: calc(100vh - 50px);
  overflow: auto;
}
.header-text {
  padding: 16px 16px 6px 16px;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: bold;
}
.table-wrap {
  padding: 0px 15px;
}
</style>
